// Einstellungen → System → Daten exportieren (W18 of APP-PARITY.md "Detail-Abgleich"; Dominik 19.10.2026: "ich fand nur den export als
// option cool, falls man die DAten irgendwo anders verwenden will. aber das sollte nicht als sicherung gelten"): the
// whole cloud history as JSON and the shots as CSV, downloaded with the session cookie. Board "System": "Daten
// exportieren (i)", two buttons over the whole width with a download icon.
import { exportView } from '../../core/index.js';
import { Card, CardHeader, Icon } from '../components/index.js';
import { useMachine } from '../machine-context.js';
import { useDeviceApi } from './use-device.js';

export function ExportCard() {
  const { ctx, machineId } = useMachine();
  const api = useDeviceApi();
  const e = exportView(ctx);
  return (
    <Card className="tab-card" data-testid="export">
      <CardHeader title={e.title} info={{ text: e.hint, label: ctx.tr('infoShow'), testId: 'export-info' }} />
      <div className="sheet-actions">
        <a
          className="btn btn-secondary btn-md btn-block"
          href={api.exportHref(machineId)}
          download
          data-testid="export-json"
        >
          <Icon name="download" size="sm" />
          {e.json}
        </a>
        <a
          className="btn btn-secondary btn-md btn-block"
          href={api.csvHref(machineId, ctx.lang)}
          download
          data-testid="export-csv"
        >
          <Icon name="download" size="sm" />
          {e.csv}
        </a>
      </div>
    </Card>
  );
}
